// Tokens for the design-system Chip and its children (Avatar, Flag, Glyph).

export type ChipSize = 'sm' | 'md' | 'lg';
export type ChipColor = 'highlight' | 'primary';

// sm 14 / md 20 / lg 32. Matches the Figma scale.
export const containerSize: Record<ChipSize, string> = {
  sm: 'size-3.5',
  md: 'size-5',
  lg: 'size-8',
};

// Rounded squares — sm 6px, md 8px, lg 12px (DS radius-sm / -md / -xl).
export const radius: Record<ChipSize, string> = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-xl',
};

// Single-letter for sm/md, two letters for lg.
export const initialLength: Record<ChipSize, 1 | 2> = {
  sm: 1,
  md: 1,
  lg: 2,
};

export const initialTextSize: Record<ChipSize, string> = {
  sm: 'text-2xs leading-none',
  md: 'text-xs leading-none',
  lg: 'text-body-12-bold leading-none',
};

// Font-icon glyph: sm 10 / md 14 / lg 18.
export const iconGlyphSize: Record<ChipSize, string> = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-ml',
};

// Flag wrapper: inset SVG with a 1px primary-10 border for edge visibility
// against the tinted tile.
export const flagInset: Record<ChipSize, string> = {
  sm: 'size-2.5 rounded-xs border border-primary-10',
  md: 'size-3.5 rounded-sm border border-primary-10',
  lg: 'size-5 rounded-md border border-primary-10',
};

export const colorSurface: Record<ChipColor, string> = {
  highlight: 'bg-highlight-medium text-highlight-darkest',
  primary: 'bg-primary-10 text-primary-100',
};
